import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatRegisters = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        day: item.day && moment(item.day),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchRegisters,
    create: createRegister,
    update: updateRegister,
    delete: deleteRegisters
} = createCrudActions('REGISTER', "Registro", formatRegisters);
